var render, staticRenderFns
import script from "./invoice_info_item.vue?vue&type=script&lang=js"
export * from "./invoice_info_item.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('18a0b0ae')) {
      api.createRecord('18a0b0ae', component.options)
    } else {
      api.reload('18a0b0ae', component.options)
    }
    
  }
}
component.options.__file = "found/views/mdm/views/customer_information/components/invoice_info/invoice_info_item.vue"
export default component.exports